import util from '@/util/util'
import axios from 'axios'

class ConfigModel {
	async getCommonConfig() {
		const res = await axios.get(
			`https://static.nio.com/fx-static/1264/fixed/commonConfig.${util.getEnvStr()}.json?timestamp=${Date.now()}`
		)
		return res.data || {}
	}
}

export default new ConfigModel()
